import * as Yup from 'yup'

const voucherFormSchema = Yup.object({
  voucherId: Yup.string().required('Debes seleccionar el bono que quieres comprar'),
})

export default voucherFormSchema
